import React from 'react'
import {
  Button,
  SimpleModal,
  ModalTitle,
  ModalContent,
  ModalFooter,
  TextField
} from '@deal/components'
import styles from './styles.css'
import { CreateShareLinkComponent } from '#src/generated/graphql'

interface ShareModalProps {
  onRequestClose: () => void
  createShortUrl: () => void
  shortUrl?: string
  loading: boolean
}

class ShortLinkModal extends React.Component<ShareModalProps, {}> {
  public componentDidMount() {
    this.props.createShortUrl()
  }

  public render() {
    const { onRequestClose, shortUrl, loading } = this.props
    return (
      <SimpleModal
        isOpen={true}
        onRequestClose={onRequestClose}
        overlayClassName={styles.modalOverlay}
      >
        <ModalTitle>Send to a friend</ModalTitle>
        <ModalContent className={styles.modalContent}>
          <p className={styles.modalText}>Share with a friend via the link below!</p>
          <TextField
            loading={loading}
            value={shortUrl}
            display="standard"
            autoFocus={false}
            label="shortCode"
            labelHidden={true}
          />
        </ModalContent>
        <ModalFooter className={styles.modalFooter}>
          <Button onClick={onRequestClose} variant="black">
            Okay!
          </Button>
        </ModalFooter>
      </SimpleModal>
    )
  }
}

interface ShortUrlProps {
  shareUrl: string
  preferredDomain?: string
  onRequestClose: () => void
}

interface ShortUrlState {
  shortUrl?: string
}

class ShortUrl extends React.Component<ShortUrlProps, ShortUrlState> {
  constructor(props: ShortUrlProps) {
    super(props)

    this.state = {}
  }
  render() {
    const { shareUrl, preferredDomain, ...rest } = this.props
    return (
      <CreateShareLinkComponent
        variables={{
          input: {
            url: shareUrl,
            preferredDomain
          }
        }}
        onCompleted={data => data.shortenUrl && this.setState({ shortUrl: data.shortenUrl.url })}
      >
        {(createShortUrl, { loading }) => (
          <ShortLinkModal
            {...rest}
            createShortUrl={() => createShortUrl()}
            shortUrl={this.state.shortUrl}
            loading={loading}
          />
        )}
      </CreateShareLinkComponent>
    )
  }
}

export default ShortUrl
